export default "__VITE_ASSET__DtRMwzYL__"